
import apiInstance from '../utils/apiInstance';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Swal from "sweetalert2";
import 'react-toastify/dist/ReactToastify.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Table from '../common/Table';

const WaiterList = () => {
    const { _id } = useParams();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [sortedData, setSortedData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");

    async function fetchData() {
        try {
            const response = await apiInstance.get(`/waiterList/${_id}`);
            setData(response.data.restaurantDetails?.waiters);
        } catch (error) {
            setError("An error occurred while fetching restaurant's waiter list...");
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        fetchData();
    }, [_id]);

    useEffect(() => {
        if (data && Array.isArray(data)) {
            const sorted = [...data].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            setSortedData(sorted);
        }
    }, [data]);
    const filteredData = sortedData.filter(waiter =>
        waiter?.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        waiter?.email.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const handleDeleteClick = async (id) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
            customClass: {
                popup: 'custom-swal-popup',
                title: 'custom-swal-title',
                content: 'custom-swal-content',
                confirmButton: 'custom-swal-button',
                cancelButton: 'custom-swal-button'
            }
        });
        if (result.isConfirmed) {
            if (id) {
                setLoading(true);
                try {
                    await apiInstance.delete(`/deleteWaiter/${id}`);
                    Swal.fire("Deleted!", "Waiter has been deleted.", "success");
                    fetchData();
                } catch (error) {
                    Swal.fire(
                        "Error!",
                        "Error deleting waiter",
                        "error"
                    );
                } finally {
                    setLoading(false);
                }
            }
        }

    };

    const options = ['S No.', 'Profile', 'Name', 'Email', 'Phone No.', 'Actions'];

    if (error) return <div>{error}<br />Please try again after some time or check your internet connection.</div>;

    return (
        <>
            <Table
                waiter='waiter'
                heading='Waiters'
                options={options}
                data={filteredData}
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                loading={loading}
                navigateId={_id}
                handleDeleteClick={handleDeleteClick}
            />

            {loading && (
                <div className="loader" style={{ position: 'absolute', top: '50%', left: '59%', transform: 'translate(-50%, -50%)' }}>
                    <div className="spinner-border text-info" role="status" style={{ width: '50px', height: '50px' }}>
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            )}
        </>
    );
};

export default WaiterList;





